import useSeo from "../lib/useSeo";

const SITE_URL = process.env.PUBLIC_URL;
const ASSET_URL = process.env.PUBLIC_URL || "";

export default function Process() {
  useSeo({
    title: "Restoration Process | Evon Polishing",
    description:
      "A clear and respectful restoration process for Catholic liturgical metalware, from quote and collection through restoration, quality assurance, and return.",
    canonical: `${SITE_URL}/process`,
  });

  return (
    <section className="section stone">
      <div className="container">
        <header className="section-head">
          <h1>Our Process</h1>
          <p className="muted">
            Each project is handled carefully, communicated clearly, and restored
            with respect for sacred use.
          </p>
        </header>

        <ol className="steps">
          {/* STEP 1 */}
          <li className="step">
            <img
              className="step-icon"
              src={`${ASSET_URL}/icons/process-1.png`}
              alt="Assessment and quote"
            />
            <div className="step-content">
              <h3>Quote</h3>
              <p className="muted">
                We begin by evaluating the items requiring restoration. Whenever
                possible, this is done in person with priests, parish staff, or
                sponsors. When travel is not practical, quotes are prepared based
                on photographs and details provided by email.
              </p>
            </div>
          </li>

          {/* STEP 2 */}
          <li className="step">
            <img
              className="step-icon"
              src={`${ASSET_URL}/icons/process-2.png`}
              alt="Pick-up and collection"
            />
            <div className="step-content">
              <h3>Pick-Up / Collection</h3>
              <p className="muted">
                For in-person visits, approved items are collected at that time
                and transported securely to our workshop. When handled remotely,
                we coordinate courier collection and professional packaging for
                safe transit.
              </p>
            </div>
          </li>

          {/* STEP 3 */}
          <li className="step">
            <img
              className="step-icon"
              src={`${ASSET_URL}/icons/process-3.png`}
              alt="Restoration work"
            />
            <div className="step-content">
              <h3>Restoration Work</h3>
              <p className="muted">
                All restoration is performed in our workshop using methods
                appropriate to the item’s materials, condition, and liturgical
                use. Work is carried out with restraint, prioritizing preservation
                over alteration.
              </p>
            </div>
          </li>

          {/* STEP 4 */}
          <li className="step">
            <img
              className="step-icon"
              src={`${ASSET_URL}/icons/process-4.png`}
              alt="Quality assurance inspection"
            />
            <div className="step-content">
              <h3>Quality Assurance</h3>
              <p className="muted">
                Before any item is returned, it undergoes a final quality review.
                This includes inspection of surface finish, plating uniformity,
                structural integrity, and overall presentation under controlled
                lighting.
              </p>
            </div>
          </li>

          {/* STEP 5 */}
          <li className="step">
            <img
              className="step-icon"
              src={`${ASSET_URL}/icons/process-5.png`}
              alt="Return and delivery"
            />
            <div className="step-content">
              <h3>Return / Delivery</h3>
              <p className="muted">
                Whenever possible, restored items are returned in person. When
                in-person return is not practical, items are securely packaged
                and shipped via courier with careful handling in mind.
              </p>
            </div>
          </li>
        </ol>

        {/* Closing summary */}
        <p className="muted process-summary">
          Throughout the process, we do our best to ensure an easy and smooth
          experience from start to finish. Clear communication is maintained at
          each stage, and updates are provided when available so that parishes
          and sponsors remain informed from initial quote through final return.
        </p>
      </div>
    </section>
  );
}
